// ** React Imports
import { createContext, useEffect } from "react"

// ** Intl Provider Import
import { IntlProvider } from "react-intl"

// ** Core Language Data

// ** User Language Data
import { languagesApi } from "../../api/languages"
import { handleLanguageKey, handleLanguageWords } from "../../redux/actions/config"
import { useDispatch, useSelector } from "react-redux"

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children, global }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.config.languageKey)
  const messages = useSelector((state) => state.config.languageWords)

  const getLanguage = async () => {
    try {
      const { data } = await languagesApi.getWordsByCode(locale)
      dispatch(handleLanguageWords(data))
    } catch {}
  }

  // ** Switches Language
  const switchLanguage = (lang) => {
    dispatch(handleLanguageKey(lang))
    localStorage.setItem("lang", lang)
    getLanguage(lang)
  }

  useEffect(() => {
    if (global) getLanguage()
  }, [locale])

  return (
    Object.keys(messages).length > 0 && (
      <Context.Provider value={{ locale, switchLanguage }}>
        <IntlProvider key={locale} locale={locale} messages={messages}>
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  )
}

export { IntlProviderWrapper, Context as IntlContext }
